<template>
  <div
    class="modal custom-modal fade"
    id="edit_group"
    role="dialog"
    :showUpdateGroup.sync="showUpdateGroup"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add to Group</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="updateContact">
            <div class="form-group">
              <!-- {{formCreateContact}} -->
              <!-- {{formUpdateContact.list_id}} -->
              <label class="d-block">
                Contacs Selected:
                <b>{{selectedCheckbox.length}}</b> Data.
              </label>
            </div>
            <div class="form-group">
              <!-- {{formCreateContact}} -->
              <label class="d-block">Group</label>
              <div class="task-wrapper">
                <div class="task-list-container">
                  <div class="task-list-body">
                    <ul id="task-list">
                      <template v-for="rowG in groupListArr">
                        <li
                          v-on:click="selectGroup(rowG.id);"
                          v-bind:id="'upg-'+rowG.id"
                          class="task"
                          :key="rowG.id"
                        >
                          <div class="task-container">
                            <span class="task-action-btn task-check">
                              <span class="action-circle large complete-btn" title="Select">
                                <i class="material-icons">check</i>
                              </span>
                            </span>
                            <span class="task-label" contenteditable="false">{{rowG.name}}</span>
                          </div>
                        </li>
                      </template>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="submit-section">
              <button :disabled="loading" class="btn btn-primary submit-btn">Submit</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Skeleton } from "vue-loading-skeleton";

export default {
  components: {
    Skeleton
  },
  data() {
    return {
      loadingGroup: false,
      groupListParam: {
        name: "",
        page: 0,
        perPage: 1000
      },
      loading: false,
      formUpdateContact: {
        id: "",
        email: "",
        phone_number: "",
        first_name: "",
        last_name: "",
        list_id: []
      }
    };
  },
  computed: {
    groupListArr() {
      return this.$store.state.contact.groupListArr;
    }
  },
  watch: {
    showUpdateGroup: {
      handler: function(val, oldVal) {
        // console.log("val", val);
        // console.log("oldVal", oldVal);
        // if (val != "") {
        //   this.viewContact(val);
        // }
      },
      deep: true
    }
  },
  props: {
    filterContactListGroup: {
      type: Function
    },
    showUpdateGroup: {
      type: String,
      default: ""
    },
    selectedCheckbox: {
      type: Array,
      default: []
    }
  },
  methods: {
    async getGroupList() {
      this.loadingGroup = await false;
      await this.$store
        .dispatch("contact/getGroupList", this.groupListParam) // sesuai kan dengan method di API
        .catch(error => {
          this.loadingGroup = false;
        });
    },
    hasClass(element, className) {
      return (
        (" " + element.className + " ").indexOf(" " + className + " ") > -1
      );
    },
    resetSelected() {
      if (this.groupListArr.length > 0) {
        this.groupListArr.forEach(function(row, index) {
          // console.log("vaaaa", value);
          // if (this.hasClass("up-" + row.id, "completed")) {
          var element = document.getElementById("up-" + row.id);
          element.classList.remove("completed");
          // }
        });
      }
    },

    async updateContact() {
      if (this.selectedCheckbox.length < 1) {
        this.$fire({
          title: "Warning",
          text: "Please select one or more contacts to update",
          type: "warning",
          timer: 3000
        });
        return;
      }
      this.loading = await true;
      await this.selectedCheckbox.forEach((contactId, index) => {
        let newParam = {
          id: contactId,
          list_id: this.formUpdateContact.list_id
        };
        this.$store
          .dispatch("contact/addContactToList", newParam)
          .catch(err => {
            this.loading = false;
            return;
          });
      });
      await this.$fire({
        title: "Success",
        text:
          "Success for update " + this.selectedCheckbox.length + " contacts",
        type: "success",
        timer: 3000
      });
      await this.getGroupList();
      await this.formUpdateContact.list_id.forEach((value, index) => {
        var element = document.getElementById("upg-" + value);
        element.classList.remove("completed");
      });
      this.loading = await false;
    },
    async selectGroup(id) {
      // console.log("selgr", id);
      var element = document.getElementById("upg-" + id);
      if (this.formUpdateContact.list_id.length > 0) {
        var isFound = false;
        var indexFound = -1;
        await this.formUpdateContact.list_id.forEach((value, index) => {
          if (value === id) {
            indexFound = index;
          }
        });

        if (indexFound >= 0) {
          element.classList.remove("completed");
          this.formUpdateContact.list_id.splice(indexFound, 1);
        } else {
          // this.$refs
          element.classList.add("completed");
          this.formUpdateContact.list_id.push(id);
        }
      } else {
        element.classList.add("completed");
        this.formUpdateContact.list_id.push(id);
      }
    }
  },
  async created() {},
  async mounted() {},
  name: "update-contacts"
};
</script>


// WEBPACK FOOTER //
// src/views/contacts/updateGroup.vue